import { AdvancedSearchFormValues } from "services/search";
import { FleetVehicle } from "../vehicles/types";
import { FleetWarehouse } from "../warehouses/types";
import { FileExtended } from "ui/components/FileUpload/FileDropZone/types";

export interface TireType {
  id: string;
  name: string;
}

export interface TireWidth {
  id: string;
  name: string;
}

export interface TireHeight {
  id: string;
  name: string;
}

export interface TireRadius {
  id: string;
  name: string;
}


export interface FleetTireWarehouse {
  id: string;
  name: string;
}

export interface FleetTireManufacturer {
  id: string | null;
  name: string | null;
}

/*---------------------------------------------------------------
    TIRE SET
  ---------------------------------------------------------------*/
export interface FleetTireSet {
  id: string;
  tires: FleetTireAddRow[];
  code: string;
  isActive: boolean;
  isWrittenOff: boolean;
  writtenOffAt: string | null;
  warehouse: FleetWarehouse;
  vehicle: FleetVehicle;
  // locations:  FleetTireSetLocation[];
}

export interface FleetTireSetWriteOffFormValues {
  ecologicallyDisposed: boolean;
  writeOffDate: Date | null;
  uploads: import("services/api/fleet/vehicles/documents/types").FleetDocumentUpload[];
}
/*---------------------------------------------------------------
    TIRE SET - SEARCH
  ---------------------------------------------------------------*/
export interface FleetTireSetRow {
  id: string;
  code: string;
  isActive: boolean;
  isWrittenOff: boolean;
  location: FleetTireSetLocation;
  vehicle: FleetVehicle | null;
  lastVehicle: FleetVehicle | null;
  childRows?: FleetTireRow[];
}

export interface FleetTireSetSearchFormValues {
  search: string | null;
  width: number | null;
  height: number | null;
  radius: number | null;
  vehicleManufacturerId: string | null;
  vehicleModelId: string | null;
  vehicleTypeId: string | null;
  warehouseId: string | null;
  tireManufacturerId: string | null;
  tireTypeId: string | null;
  dot: number | null;
  profileDepth: number | null;
  advancedSearch: AdvancedSearchFormValues[];
}

/*---------------------------------------------------------------
  TIRE SET - DETAILS
  ---------------------------------------------------------------*/

export interface FleetTireSetDetailFormValues {
  id?: string | null;
  dimension: [];
  tireType: TireType | null;
  location: string | null;
  tires: FleetTire[];
}


/*---------------------------------------------------------------
    TIRE - SET -  EDIT
  ---------------------------------------------------------------*/

export interface FleetTireSetAddFormValues {
  id: string | null;
  width: number | null;
  height: number | null;
  radius: number | null;
  quantity: number | null;
  tireTypeId: string | null;
  dot: number | null;
  profileDepth: number | null;
  manufacturerId: string | null;
}

export interface FleetTireSetEditFormValues {
  id: string | null;
  code: string | null;
  isActive: boolean;
  tires: FleetTireAddRow[];
  vehicle: FleetVehicle | null;
  warehouse: FleetWarehouse | null;
  tireSetReplacement: FleetTireSetReplacementFormValues | null;
}

export interface FleetTireSetLocation {
  id?: string;
  entityName: FleetTireSetLocationEntityType;
  entityId: string;
  destination?: string;
  isActive: boolean;
}

export enum FleetTireSetLocationEntityType {
  Vehicle = "Vehicle",
  Warehouse = "Warehouse",
}

export interface FleetTireSetReplacementFormValues {
  tireSetId: string | null;
  warehouseId: string | null;
  replacementDate: Date | null;
}


export interface FleetTireSetTransferFormValues {
  transferType: "to-warehouse" | "to-vehicle" | "to-other-warehouse" | null;
  targetWarehouseId: string | null;
  targetVehicleId: string | null;
  transferDate: Date | null;
  newTireSetId: string | null;
  oldSetWarehouseId: string | null;
}

export interface FleetTireSetDocument {
  id: string;
  name: string;
  description: string;
  documentType: FleetTireSetDocumentType;
  tireSet: FleetTireSet;
  created: Date;
  uploads: FleetTireSetDocumentUpload;
}

export interface FleetTireSetDocumentType {
  id: string;
  name: string;
}

export interface FleetTireSetDocumentRow {
  id: string;
  name: string;
  description: string;
  created: Date;
  documentType: FleetTireSetDocumentType;
  vehicle: FleetVehicle;
  childRows?: FleetTireSetDocumentUploadRow[];
}

export interface FleetTireSetDocumentSearchFormValues {
  search: string | null;
}

export interface FleetTireSetDocumentEditFormValues {
  id?: string | null;
  name: string | null;
  description: string | null;
  documentTypeId: string | null;
  files: FileExtended[];
}


export interface FleetTireSetDocumentUpload {
  id: string;
  originalFileName: string;
  fileExtension: string;
  fileSizeKb: number;
  contentType: string;
  created: Date;
  url: string;
}

export interface FleetTireSetDocumentUploadRow {
  documentId: string;
  id: string;
  originalFileName: string;
  created: Date;
  url: string;
}


/*---------------------------------------------------------------
    TIRE
  ---------------------------------------------------------------*/

export interface FleetTire {
  id: string;
  name: string | null;
  width: number;
  height: number;
  radius: number;
  tireType: TireType;
  tireManufacturer: FleetTireManufacturer;
  dot: number | null;
  profileDepth: number | null;
}




/*---------------------------------------------------------------
    TIRE - SEARCH
  ---------------------------------------------------------------*/

export interface FleetTireRow {
  id: string;
  name: string | null;
  width: number;
  height: number;
  radius: number;
  tireType: TireType;
  tireManufacturer: FleetTireManufacturer;
  dot: number | null;
  profileDepth: number | null;
}

export interface FleetTireSearchFormValues {
  search: string | null;
  width: number | null;
  height: number | null;
  radius: number | null;
  vehicleManufacturerId: string | null;
  vehicleModelId: string | null;
  vehicleTypeId: string | null;
  warehouseId: string | null;
  dot: number | null;
  profileDepth: number | null;
  advancedSearch: AdvancedSearchFormValues[];
}

/*---------------------------------------------------------------
    TIRE - EDIT - FORM
  ---------------------------------------------------------------*/

export interface FleetTireEditFormValues {
  id?: string | null;
  width: number | null;
  height: number | null;
  radius: number | null;
  quantity: number | null;
  dot: number | null;
  profileDepth: number | null;
  rof: boolean;
  tireManufacturerId: string | null;
  tireTypeId: string | null;
  axlePosition: number | null;
}

export interface FleetTireAddFormValues {
  id?: string | null;
  width: number | null;
  height: number | null;
  radius: number | null;
  quantity: number | null;
  dot: number | null;
  profileDepth: number | null;
  rof: boolean;
  tireManufacturerId: string | null;
  tireTypeId: string | null;
  vehicleId: string | null;
  axlePosition: number | null;
}

/*---------------------------------------------------------------
    TIRE - EDIT - ROW
  ---------------------------------------------------------------*/
export interface FleetTireAddRow {
  id?: string | null;
  width: number | null;
  height: number | null;
  radius: number | null;
  quantity: number | null;
  dot: number | null;
  profileDepth: number | null;
  rof: boolean;
  tireManufacturer: FleetTireManufacturer | null;
  tireType: TireType | null;
  warehouse: FleetTireWarehouse | null;
  vehicle: FleetVehicle | null;
}

/*---------------------------------------------------------------
     TIRE -  DETAILS
  ---------------------------------------------------------------*/

export interface FleetTireDetailFormValues {
  id?: string | null;
}
